import { GET, POST, POSTNEW, download, UPLOADINGNEW, uploading, POSTFormData, EXPORTNEW, uploadingImg, DELETENEW, GETNEW, POSTFormDataNEW } from '@/request/http'

// 创建计划
export const createDSPlan = p => POSTNEW('/studentgrowthfiles/difficultStudent-apply/save', p)

// 获取计划
export const getDSTableData = p => POSTNEW('/studentgrowthfiles/difficultStudent-apply/findPage', p)

// 一键审核按钮
export const selectStateByOperator = p => POSTNEW('/studentgrowthfiles/difficultStu-apply/selectStateByOperator', p)

// 统计信息（列表上5个圆状图）
export const getStatisticsInfo = p => POSTNEW('/studentgrowthfiles/difficultStu-apply/getStatisticsInfo', p)

// 困难生导出
export const difficultStuExportData = p => EXPORTNEW('/studentgrowthfiles/difficultStu-apply/export', p)

// 困难生显示的申请人数，显示的通过人数(学工和学院)
export const getFacultyPersonNumInfo = p => POSTNEW('/studentgrowthfiles/plan/apply/getFacultyPersonNumInfo', p)

// 困难生显示的申请人数，显示的通过人数(辅导员)
export const difficultStudentPage = p => POSTNEW('/studentgrowthfiles/difficultStu-apply/difficultStudentPage', p)

// 根据类别获取配置信息
export const findListByClassId = p => GETNEW('/studentgrowthfiles/plan-basic/config-define/findListByClassId', p)

// 改变计划状态
export const dsupdateState = p => POSTNEW('/studentgrowthfiles/plan/config/updateState', p)

// 根据类别获取配置信息
export const editDSPlan = p => GETNEW('/studentgrowthfiles/difficultStudent-apply/getBasicInfo', p)

// 学工查看公示照片
export const getPublicNotice = p => POSTNEW('/studentgrowthfiles/difficultStu-apply/getPublicNotice', p)

// 学工下载公示照片（学工）
export const dsDownLoadpublicNotice = p => EXPORTNEW('/studentgrowthfiles/difficultStu-apply/downLoadpublicNotice', p)

// 辅导员下载审批单
export const dsdownApplyListByCounselor = p => GETNEW('/studentgrowthfiles/difficultStu-apply/downApplyListByCounselor', p)

// 学院公示照片
export const dspubliPhoto = p => POSTNEW('/studentgrowthfiles/difficultStu-apply/publicity', p)

//获取困难生认定成功列表
export const getApplyDifficultsStudentList = p => POSTNEW('/studentgrowthfiles/plan/apply/page/DIFFICULT_STUDENT', p)

//获取国家助学金认定成功列表
export const getApplyNATIONAL_GRANTSList = p => POSTNEW('/studentgrowthfiles/plan/apply/page/NATIONAL_GRANTS', p)

//获取国家励志奖学金认定成功列表
export const getApplyENCOUNR_SCHOLARList = p => POSTNEW('/studentgrowthfiles/plan/apply/page/ENCOUNR_SCHOLAR ', p)

// 上传图片
export const ImageUploadDs = p => uploadingImg('/basic/aliyun-oos/upload-image/studentgrowthfiles-difficultStudent', p)

//困难生管理分页
export const getDifficultStudentComp = p => POSTNEW('/studentgrowthfiles/difficultStu-apply/getDifficultStudentComp', p)

// 获取困难生类型
export const getDsStudentType = p => GETNEW('/studentgrowthfiles/plan/options/findListBycodes', p)

// 困难生管理导出
export const dsStuAdminExportData = p => EXPORTNEW('/studentgrowthfiles/difficultStu-apply/exportDifficultStudentComp', p)

// 国家助学金导出
export const ngStuAdminExportData = p => EXPORTNEW('/studentgrowthfiles/nationalGrants-apply/export', p)

// 困难生管理导入
export const importExportDifficultStudentAdministration = p => POSTFormDataNEW('/studentgrowthfiles/difficultStu-apply/importStudentDifficult', p)

// 下载审批单
export const dsDownloadForm = p => EXPORTNEW('/studentgrowthfiles/difficultStu-apply/queryApplyNoList', p)

// 国家励志奖学金导出
export const scholarshipExportData = p => EXPORTNEW('/studentgrowthfiles/ecourageScholar-apply/export', p)

// 研究生阅读国家助学金下载审批单
export const scholarshipReadingExportData = p => EXPORTNEW('/studentgrowthfiles/nationalGrantsRead/queryApplyNoList', p)


// WEBPACK FOOTER //
// ./src/api/modules/difficultStudent.js